export enum EXTRACHARGE_ALIAS {
  photoVignette = 'fotovineta'
}

export const EXTRACHARGE = {
  'fotovineta': {
    input: 'photoVignette',
    style: 'photoVignette',
    styleValue: true
  },
  '1-estrella': {
    input: 'star-1',
    style: 'starCount',
    styleValue: 1
  },
  '2-estrellas': {
    input: 'star-2',
    style: 'starCount',
    styleValue: 2
  },
  'negrita': {
    input: 'bold',
    style: 'bold',
    styleValue: true
  },
  'titulo-centrado': {
    input: 'titleCenter',
    style: 'titleCenter',
    styleValue: true
  },
  'resaltado-amarillo': {
    input: 'marker',
    style: 'highlight',
    styleValue: true
  },
  'vineta': {
    input: 'vignette',
    style: 'vignette',
    styleValue: true
  },
  'encabezado-simple': {
    input: 'header-1',
    style: 'header',
    styleValue: 'simple'
  },
  'encabezado-doble': {
    input: 'header-2',
    style: 'header',
    styleValue: 'doble'
  },
  'palabra-extra': {
    input: 'extraWord',
    style: 'extraWord',
    styleValue: true
  }
}
